export default {"src":"/_next/static/media/xIcon.082d7562.svg","height":37,"width":37};